import { uniqueId } from 'lodash-es';
import { GlAvatarLink, GlAvatar, GlTooltip } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'UserLinkWithTooltip',
    components: {
        GlAvatarLink,
        GlAvatar,
        GlTooltip
    },
    props: {
        avatar: {
            type: Object,
            required: true
        },
        label: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            toggleId: uniqueId('user-link-')
        };
    }
};
